import { CommonHttpOption } from "./../../base/common-http-option";
import { Injectable, Output, EventEmitter } from "@angular/core";
import { CoreService } from "../../base/core";
import { Observable } from "rxjs";
import { ServiceRoute } from "../../base/service-route";
import { ICourseHistory } from "src/app/interfaces/course-history";

@Injectable({
  providedIn: "root"
})
export class CourseHistoryService {
  @Output() change: EventEmitter<boolean> = new EventEmitter();
  constructor(private core: CoreService) {}

  list(page: number = 0, pageSize: number = 0): Observable<any> {
    return this.core.get(
      ServiceRoute.courseHistory.list,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(page, pageSize)
    );
  }

  getById(id: number): Observable<any> {
    return this.core.get(
      ServiceRoute.courseHistory.getById + id,
      new CommonHttpOption().headers
    );
  }

  add(data: ICourseHistory): Observable<any> {
    return this.core.post(
      ServiceRoute.courseHistory.add,
      data,
      new CommonHttpOption().headers
    );
  }

  edit(data: ICourseHistory): Observable<any> {
    return this.core.put(
      ServiceRoute.courseHistory.edit,
      data,
      new CommonHttpOption().headers
    );
  }

  delete(id: any): Observable<any> {
    return this.core.delete(
      ServiceRoute.courseHistory.delete + id,
      new CommonHttpOption().headers
    );
  }

  fire() {
    this.change.emit();
  }
}
